import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import * as _ from 'lodash-es';

/**
 * Batch delete for EC Threshold Management.
 *
 * AngularJS parity: ecThresholdSetupActionsController.js `vm.delete()` posted the
 * selected grid rows to `saveJsonObject?action_code=p8r1d0` with
 * `json_data = JSON.stringify(gridData.map(({data}) => data))`, merging
 * `GlobalService.globalParams` + `filterParams` and `is_issue_key_enabled = 'N'`.
 */
@Injectable({
  providedIn: 'root'
})
export class EcThresholdDeleteService {

  constructor(private http: HttpClient) { }

  deleteThresholdData(
    baseUrl: string,
    rows: any[],
    globalParams: any,
    filterParams: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=p8r1d0`;

    let params: any = _.merge({}, globalParams || {}, filterParams || {});
    params = _.extend({ json_data: JSON.stringify(rows || []) }, params);
    params.is_issue_key_enabled = 'N';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        formData.set(key, params[key]);
      }
    });

    return this.http.post<any>(url, formData.toString(), { ...httpOptions, withCredentials: true })
      .pipe(map(response => response as any));
  }
}
